import { useContext, useState } from "react";
import { MdMailOutline, MdOutlinePassword } from "react-icons/md";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import LoginPageImg from "../../../assets/img/login_image.png";
import { AuthContext } from "../../../Provider/AuthProvider";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { signIn } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const navLinks = (
    <>
      <li className="px-2">
        <NavLink to="/">Home</NavLink>
      </li>
      {/* <li className="px-2">
        <NavLink to="/admin/register">Register</NavLink>
      </li> */}
      <li className="px-2">
        <NavLink to="/admin/login">Login</NavLink>
      </li>
    </>
  );

  const handleLogin = (e) => {
    e.preventDefault();
    const from = new FormData(e.currentTarget);
    const email = from.get("email");
    const password = from.get("password");

    signIn(email, password)
      .then(async (result) => {
        const loggedInUser = result.user;

        // ✅ Get Firebase ID token
        const token = await loggedInUser.getIdToken();
        localStorage.setItem("access-token", token); // store token

        // Navigate after login
        const fromPath = location.state?.from?.pathname || "/dashboard";
        navigate(fromPath, { replace: true });
      })
      .catch((error) => {
        if (error.code === "auth/invalid-credential") {
          alert("Invalid credentials. Please check your email and password.");
        } else {
          Swal.fire({
            title: "Login Failed",
            text: "No account found or something went wrong.",
            icon: "error",
            showCancelButton: true,
            confirmButtonText: "Try Again",
            cancelButtonText: "Go to Register",
          }).then((result) => {
            if (!result.isConfirmed) {
              navigate("/admin/register");
            }
          });
        }
      });
  };

  return (
    <div>
      <div className="navbar absolute">
        <div className="navbar-start" />
        <div className="navbar-end lg:flex">
          <ul className="menu menu-horizontal px-1">{navLinks}</ul>
        </div>
      </div>

      <div className="hero-content mx-auto flex-col gap-10 lg:flex-row">
        <div className="hidden lg:block text-center">
          <img
          loading="lazy"
            className="h-[50rem]"
            src={LoginPageImg}
            alt="Login Illustration"
          />
        </div>

        <div className="w-full lg:w-1/2 lg:p-10">
          <form onSubmit={handleLogin}>
            <h1 className="text-5xl pt-20 lg:pt-0 font-bold">Sign In</h1>

            <div className="form-control border-t-2 pt-8 mt-8">
              <h2 className="text-xs">Continue with email address</h2>
              <label className="label pt-2">
                <span className="font-bold pt-2">Email</span>
              </label>
              <div className="input input-bordered flex gap-2 items-center">
                <MdMailOutline className="text-xl text-[#ababab]" />
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email address"
                  className="w-full"
                  required
                />
              </div>
            </div>

            <div className="form-control">
              <label className="label pt-2">
                <span className="font-bold pt-2">Password</span>
              </label>
              <div className="input input-bordered flex gap-2 items-center">
                <MdOutlinePassword className="text-xl text-[#ababab]" />
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter your password"
                  className="w-full"
                  required
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  className="text-sm text-gray-600 cursor-pointer"
                >
                  {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                </span>
              </div>
              <label className="label pt-2">
                <a href="/admin/resetPassword" className="pt-2 label-text link link-hover">
                  Forgot password?
                </a>
              </label>
            </div>

            <div className="form-control mt-6">
              <button className="btn border-0 text-xl text-white bg-[#55D4AB] hover:bg-[#f0ca4e] hover:text-black">
                Login
              </button>
            </div>
          </form>

          {/* <div className="pt-10">
            <p className="label-text">
              Don’t have an account?
              <Link to="/admin/register" className="font-semibold link-hover">
                {" "}
                Sign up
              </Link>
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
